<template>
  <div class="container-lista">
    <div>
      <div class="q-mb-md" v-if="pt.status === 'aberto' && usuarioPodeEditar">
        <div class="col-12 q-ml-sm">
          <lista-atividades :pt="pt" @closing="fechadaInclusaoAtividades()" />
        </div>
      </div>
    </div>

    <div class="atividades-container" v-if="respostaAtividade">
      <div
        v-for="atividade in respostaAtividade"
        :key="atividade.nome"
        class="atividade-card"
        :class="{ 'atividade-incompleta': !isAtividadeCompleta(atividade) }"
      >
        <div class="atividade-header">
          <div class="row items-center justify-between">
            <div class="col-auto">
              <h6 class="atividade-titulo q-ma-none">{{ atividade.nome }}</h6>
            </div>
            <div class="col-auto">
              <div class="situacao-critica row items-center">
                <span class="text-weight-medium q-mr-sm">Situação Crítica</span>
                <q-icon
                  v-if="atividade.critico === true"
                  name="done"
                  class="text-green"
                  size="md"
                >
                  <q-tooltip
                    >Se a atividade for categorizada como Crítica, devemos
                    coletar as assinaturas por atividade no status de
                    assinatura.</q-tooltip
                  >
                </q-icon>
                <q-icon v-else name="close" class="text-red" size="md">
                  <q-tooltip
                    >Essa atividade não é crítica, então não depende de
                    assinaturas específicas para a execução.</q-tooltip
                  >
                </q-icon>
              </div>
            </div>
          </div>

          <div
            v-if="!isAtividadeCompleta(atividade)"
            class="status-incompleto q-mt-sm"
          >
            <q-icon name="warning" class="text-red q-mr-xs" />
            <span class="text-red text-weight-medium"
              >Responda todas as perguntas para continuar</span
            >
          </div>

          <div
            v-if="
              pt.status === 'aberto' && usuarioPodeEditar && temPermissaoAtalho
            "
            class="atalho-buttons q-mt-md"
          >
            <div class="text-caption text-grey-7 q-mb-xs">
              Responder todas as perguntas desta atividade:
            </div>
            <q-btn
              size="sm"
              color="positive"
              icon="check_circle"
              label="Todas SIM"
              class="q-mr-sm"
              @click="responderTodasPerguntas(atividade.atividadeId, true)"
              :loading="loadingSim[atividade.atividadeId]"
              no-caps
            />
            <q-btn
              size="sm"
              color="orange"
              icon="cancel"
              label="Todas N/A"
              @click="responderTodasPerguntas(atividade.atividadeId, false)"
              :loading="loadingNA[atividade.atividadeId]"
              no-caps
            />
          </div>
        </div>

        <div class="perguntas-container">
          <div
            v-for="pergunta in getPerguntasAtividade(atividade)"
            :key="pergunta.descricao"
            class="pergunta-card"
          >
            <div class="pergunta-titulo q-mb-md">
              <span class="text-weight-medium">{{ pergunta.descricao }}</span>
            </div>

            <div class="pergunta-opcoes q-mb-md">
              <q-radio
                :disable="pt.status !== 'aberto' || !usuarioPodeEditar"
                class="q-mr-md"
                v-model="pergunta.resposta"
                v-bind:val="true"
                label="Sim"
                @update:model-value="
                  (value, event) => responderPergunta(value, event, pergunta)
                "
              />
              <q-radio
                :disable="pt.status !== 'aberto' || !usuarioPodeEditar"
                v-model="pergunta.resposta"
                v-bind:val="false"
                @update:model-value="
                  (value, event) => responderPergunta(value, event, pergunta)
                "
                label="N/A"
              />
            </div>

            <div class="pergunta-observacao">
              <div v-if="pt.status == 'aberto'">
                <q-input
                  :disable="pt.status != 'aberto' || !usuarioPodeEditar"
                  @blur="
                    (value, event) => responderPergunta(value, event, pergunta)
                  "
                  type="textarea"
                  dense
                  outlined
                  v-model="pergunta.observacao"
                  placeholder="Escreva a sua observação"
                  class="observacao-input"
                  :rows="2"
                  autogrow
                >
                  <template v-slot:prepend>
                    <q-icon name="info" class="cursor-pointer">
                      <q-tooltip class="bg-primary">
                        <div class="observacao-tooltip">
                          <div v-if="pergunta.observacao">
                            <strong>Observação atual:</strong><br />
                            {{ pergunta.observacao }}
                          </div>
                          <div v-else>
                            Adicione uma observação para esta pergunta
                            (opcional)
                          </div>
                        </div>
                      </q-tooltip>
                    </q-icon>
                  </template>
                </q-input>
              </div>

              <div
                v-if="pt.status != 'aberto' && pergunta.observacao"
                class="observacao-readonly"
              >
                <div class="text-caption text-grey-7 q-mb-xs">Observação:</div>
                <div class="observacao-text">
                  {{ pergunta.observacao }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="observacao-trabalho-container q-mt-lg">
      <div
        v-if="pt.status == 'aberto' && respostaAtividade && usuarioPodeEditar"
      >
        <div class="observacao-trabalho-titulo q-mb-sm">
          <span class="text-weight-bold">Observação do Trabalho</span>
        </div>

        <div class="nova-observacao-container q-mb-md">
          <q-input
            type="textarea"
            outlined
            v-model="novaObservacao"
            placeholder="Adicione uma nova observação sobre o trabalho"
            class="observacao-trabalho-input"
            :rows="3"
            autogrow
          />

          <div class="q-mt-sm">
            <q-btn
              color="primary"
              label="Adicionar Observação"
              icon="add_comment"
              :loading="loadingObservacao"
              :disable="!novaObservacao || novaObservacao.trim() === ''"
              @click="adicionarObservacao"
              no-caps
            />
          </div>
        </div>
      </div>

      <div v-if="observacoesHistorico && observacoesHistorico.length > 0">
        <div class="observacoes-historico-titulo q-mb-md">
          <span class="text-weight-bold">Histórico de Observações</span>
          <q-badge
            color="primary"
            :label="observacoesHistorico.length"
            class="q-ml-sm"
          />
        </div>

        <div class="observacoes-historico">
          <div
            v-for="(obs, index) in observacoesHistorico"
            :key="index"
            class="observacao-item q-mb-md"
          >
            <div class="observacao-header q-mb-xs">
              <div class="row items-center justify-between">
                <div class="col-auto">
                  <span class="text-caption text-grey-7">
                    <q-icon name="person" size="xs" class="q-mr-xs" />
                    {{ obs.usuarioNome || "Sistema" }}
                  </span>
                </div>
                <div class="col-auto">
                  <span class="text-caption text-grey-7">
                    <q-icon name="schedule" size="xs" class="q-mr-xs" />
                    {{ formatarDataHora(obs.dataHora) }}
                  </span>
                </div>
              </div>
            </div>

            <div class="observacao-conteudo">
              <q-card flat bordered class="bg-grey-1">
                <q-card-section class="q-pa-sm">
                  <div class="observacao-text">
                    {{ obs.observacao }}
                  </div>
                </q-card-section>
              </q-card>
            </div>
          </div>
        </div>
      </div>

      <div
        v-else-if="pt.status != 'aberto' || !usuarioPodeEditar"
        class="sem-observacoes text-center q-pa-md"
      >
        <q-icon name="comment" size="md" class="text-grey-5 q-mb-sm" />
        <div class="text-grey-6">Nenhuma observação foi adicionada</div>
      </div>
    </div>
  </div>
</template>

<script>
import { useQuasar } from "quasar";
import { useStore } from "vuex";
import { watch, ref, computed, onMounted, onBeforeUnmount } from "vue";
import ListaAtividades from "./ListaAtividades.vue";

const columns = [
  {
    name: "nome",
    label: "",
    align: "left",
    field: (row) => row.nome,
    format: (val) => `${val}`,
    sortable: true,
  },
];

export default {
  components: { ListaAtividades },
  props: ["pt", "usuarioPodeEditar"],
  emits: ["atividadesAtualizadas"],
  setup(props, { emit }) {
    const store = useStore();
    const quasar = useQuasar();
    const respostaAtividade = ref([]);
    const perguntas = ref();
    const observacaoAvaliacaoDeRisco = ref();
    const novaObservacao = ref("");
    const observacoesHistorico = ref([]);
    const loadingObservacao = ref(false);
    const loadingAtalho = ref({});

    const loadingSim = ref({});
    const loadingNA = ref({});

    const temPermissaoAtalho = computed(() => {
      return (
        store.state.autenticacao?.usuarioLogado?.permissoes?.gmapi?.roles?.includes(
          "pdt-atalho-atividade"
        ) || false
      );
    });

    const isAtividadeCompleta = (atividade) => {
      if (
        !atividade.respostasPerguntas ||
        atividade.respostasPerguntas.length === 0
      ) {
        return true;
      }

      return atividade.respostasPerguntas.every(
        (pergunta) =>
          pergunta.resposta !== null && pergunta.resposta !== undefined
      );
    };

    const salvarEstadoLocal = () => {
      if (props.pt && props.pt.ptId) {
        const estado = {
          respostaAtividade: respostaAtividade.value,
          observacaoAvaliacaoDeRisco: observacaoAvaliacaoDeRisco.value,
          observacoesHistorico: observacoesHistorico.value,
          timestamp: Date.now(),
        };
        localStorage.setItem(
          `pt_avaliacao_${props.pt.ptId}`,
          JSON.stringify(estado)
        );
      }
    };

    const recuperarEstadoLocal = () => {
      if (props.pt && props.pt.ptId) {
        const estadoSalvo = localStorage.getItem(
          `pt_avaliacao_${props.pt.ptId}`
        );
        if (estadoSalvo) {
          try {
            const estado = JSON.parse(estadoSalvo);
            if (Date.now() - estado.timestamp < 24 * 60 * 60 * 1000) {
              if (estado.respostaAtividade && respostaAtividade.value) {
                estado.respostaAtividade.forEach((atividadeSalva) => {
                  const atividadeAtual = respostaAtividade.value.find(
                    (a) => a.atividadeId === atividadeSalva.atividadeId
                  );
                  if (atividadeAtual) {
                    atividadeSalva.respostasPerguntas.forEach(
                      (perguntaSalva) => {
                        const perguntaAtual =
                          atividadeAtual.respostasPerguntas.find(
                            (p) => p.perguntaId === perguntaSalva.perguntaId
                          );
                        if (perguntaAtual && perguntaAtual.resposta === null) {
                          perguntaAtual.resposta = perguntaSalva.resposta;
                          perguntaAtual.observacao = perguntaSalva.observacao;
                        }
                      }
                    );
                  }
                });
              }

              if (
                estado.observacaoAvaliacaoDeRisco &&
                !observacaoAvaliacaoDeRisco.value
              ) {
                observacaoAvaliacaoDeRisco.value =
                  estado.observacaoAvaliacaoDeRisco;
              }

              if (estado.observacoesHistorico) {
                observacoesHistorico.value = estado.observacoesHistorico;
              }
            }
          } catch (error) {
            console.warn("Erro ao recuperar estado local:", error);
          }
        }
      }
    };

    const limparEstadoLocal = () => {
      if (props.pt && props.pt.ptId) {
        localStorage.removeItem(`pt_avaliacao_${props.pt.ptId}`);
      }
    };

    const responderPergunta = async (value, event, pergunta) => {
      try {
        await store.dispatch("pdt/responderPerguntaAtividade", {
          ptId: pergunta.ptId,
          atividadeId: pergunta.atividadeId,
          perguntaId: pergunta.perguntaId,
          resposta: value,
          observacao: pergunta.observacao,
        });

        quasar.notify({
          message: "Pergunta respondida com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        limparEstadoLocal();
      } catch (error) {
        salvarEstadoLocal();

        quasar.notify({
          message: "Ocorreu um erro ao responder a pergunta",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const responderTodasPerguntas = async (atividadeId, resposta) => {
      if (resposta) {
        loadingSim.value[atividadeId] = true;
      } else {
        loadingNA.value[atividadeId] = true;
      }

      try {
        const atividade = respostaAtividade.value.find(
          (a) => a.atividadeId === atividadeId
        );

        if (!atividade) {
          throw new Error("Atividade não encontrada");
        }

        const promessas = atividade.respostasPerguntas.map(async (pergunta) => {
          pergunta.resposta = resposta;

          return store.dispatch("pdt/responderPerguntaAtividade", {
            ptId: props.pt.ptId,
            atividadeId: pergunta.atividadeId,
            perguntaId: pergunta.perguntaId,
            resposta: resposta,
            observacao: pergunta.observacao,
          });
        });

        await Promise.all(promessas);

        quasar.notify({
          message: `Todas as perguntas respondidas com ${
            resposta ? "SIM" : "N/A"
          }`,
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        emit("atividadesAtualizadas");

        limparEstadoLocal();
      } catch (error) {
        console.error("Erro ao responder todas as perguntas:", error);

        salvarEstadoLocal();

        quasar.notify({
          message: "Ocorreu um erro ao responder todas as perguntas",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } finally {
        if (resposta) {
          loadingSim.value[atividadeId] = false;
        } else {
          loadingNA.value[atividadeId] = false;
        }
      }
    };

    const fechadaInclusaoAtividades = () => {
      emit("atividadesAtualizadas");
    };

    const enviarObservacaoAvaliacao = async () => {
      if (
        observacaoAvaliacaoDeRisco.value == null ||
        observacaoAvaliacaoDeRisco.value == props.pt.obsAvaliacaoRisco
      ) {
        return;
      }
      try {
        await store.dispatch("pdt/observacaoAvaliacao", {
          ptId: props.pt.ptId,
          observacao: observacaoAvaliacaoDeRisco.value,
        });
        quasar.notify({
          message: "Observação enviada com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        limparEstadoLocal();
      } catch (error) {
        console.log(error);

        salvarEstadoLocal();

        quasar.notify({
          message: "Falha ao enviar observação",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    const adicionarObservacao = async () => {
      if (!novaObservacao.value || novaObservacao.value.trim() === "") {
        return;
      }

      loadingObservacao.value = true;

      try {
        const novaObs = {
          usuarioNome:
            store.state.autenticacao?.usuarioLogado?.nome || "Usuário",
          dataHora: new Date().toISOString(),
          observacao: novaObservacao.value.trim(),
        };

        observacoesHistorico.value.push(novaObs);

        await store.dispatch("pdt/adicionarObservacao", {
          ptId: props.pt.ptId,
          observacao: novaObs.observacao,
        });

        quasar.notify({
          message: "Observação adicionada com sucesso",
          color: "positive",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });

        novaObservacao.value = "";
        limparEstadoLocal();
      } catch (error) {
        salvarEstadoLocal();

        quasar.notify({
          message: "Erro ao adicionar observação",
          color: "negative",
          actions: [
            {
              label: "fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      } finally {
        loadingObservacao.value = false;
      }
    };

    const formatarDataHora = (dataHora) => {
      const data = new Date(dataHora);
      return data.toLocaleString();
    };

    const intervalId = ref(null);

    onMounted(() => {
      recuperarEstadoLocal();

      intervalId.value = setInterval(() => {
        salvarEstadoLocal();
      }, 30000);

      window.addEventListener("beforeunload", salvarEstadoLocal);
    });

    onBeforeUnmount(() => {
      if (intervalId.value) {
        clearInterval(intervalId.value);
      }
      window.removeEventListener("beforeunload", salvarEstadoLocal);
      salvarEstadoLocal();
    });

    watch(
      () => props.pt,
      () => {
        respostaAtividade.value = props.pt.respostasAtividades;
        observacaoAvaliacaoDeRisco.value = props.pt.obsAvaliacaoRisco;
        observacoesHistorico.value = props.pt.observacoesHistorico || [];
        recuperarEstadoLocal();
      }
    );

    watch(
      [respostaAtividade, observacaoAvaliacaoDeRisco, observacoesHistorico],
      () => {
        salvarEstadoLocal();
      },
      { deep: true }
    );

    const getPerguntasAtividade = (atividade) => {
      if (!atividade.respostasPerguntas) return [];
      return atividade.respostasPerguntas.filter(
        (pergunta) => atividade.atividadeId === pergunta.atividadeId
      );
    };

    return {
      columns,
      responderPergunta,
      fechadaInclusaoAtividades,
      respostaAtividade,
      perguntas,
      observacaoAvaliacaoDeRisco,
      enviarObservacaoAvaliacao,
      responderTodasPerguntas,
      adicionarObservacao,
      formatarDataHora,
      novaObservacao,
      observacoesHistorico,
      loadingObservacao,
      loadingAtalho,
      loadingSim,
      loadingNA,
      temPermissaoAtalho,
      isAtividadeCompleta,
      getPerguntasAtividade,
    };
  },
};
</script>

<style scoped>
.container-lista {
  padding: 0 16px;
}

.atividades-container {
  columns: 2;
  column-gap: 24px;
  column-fill: balance;
}

.atividade-card {
  break-inside: avoid;
  page-break-inside: avoid;
  margin-bottom: 24px;
  display: inline-block;
  width: 100%;
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 2px solid #e0e0e0;
  transition: all 0.3s ease;
}

.atividade-card:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
}

.atividade-incompleta {
  border-color: #f44336;
}

.atividade-header {
  border-bottom: 1px solid #e0e0e0;
  padding-bottom: 16px;
  margin-bottom: 20px;
}

.atividade-titulo {
  color: #1976d2;
  font-size: 1.2rem;
  font-weight: 600;
}

.situacao-critica {
  font-size: 0.9rem;
}

.status-incompleto {
  background: #f8dcde;
  padding: 8px 12px;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
}

.atalho-buttons {
  padding: 12px;
  background: #f5f5f5;
  border-radius: 8px;
}

.perguntas-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 12px;
}

.pergunta-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 12px;
  border-left: 1px solid #8daac2;
  border-right: 1px solid #8daac2;
  border-top: 1px solid #8daac2;
  border-bottom: 1px solid #8daac2;
  min-height: auto;
}

.pergunta-titulo {
  color: #424242;
  font-size: 0.9rem;
  line-height: 1.3;
  margin-bottom: 8px;
}

.pergunta-opcoes {
  display: flex;
  gap: 12px;
  align-items: center;
  margin-bottom: 8px;
}

.pergunta-observacao {
  margin-top: 8px;
}

.observacao-input {
  background: white;
}

.observacao-input :deep(.q-field__control) {
  min-height: 32px;
}

.observacao-readonly {
  background: white;
  padding: 8px;
  border-radius: 4px;
  border: 1px solid #e0e0e0;
  font-size: 0.85rem;
}

.observacao-text {
  white-space: pre-wrap;
  word-break: break-word;
  line-height: 1.4;
  color: #424242;
  font-size: 0.85rem;
}

.observacao-tooltip {
  max-width: 300px;
  white-space: pre-wrap;
  word-break: break-word;
}

.observacao-trabalho-container {
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  border: 2px solid #e0e0e0;
}

.observacao-trabalho-titulo {
  color: #1976d2;
  font-size: 1.1rem;
}

.observacao-trabalho-input {
  background: #f8f9fa;
}

.observacao-trabalho-readonly {
  background: #f5f5f5;
  padding: 16px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
}

.nova-observacao-container {
  margin-bottom: 16px;
}

.observacoes-historico {
  margin-top: 16px;
}

.observacoes-historico-titulo {
  color: #1976d2;
  font-size: 1.1rem;
  display: flex;
  align-items: center;
}

.observacao-item {
  margin-bottom: 16px;
  border-left: 3px solid #1976d2;
  padding-left: 12px;
  transition: all 0.3s ease;
}

.observacao-item:hover {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 8px 12px;
  margin-left: -8px;
  margin-right: -8px;
}

.observacao-header {
  margin-bottom: 8px;
}

.observacao-conteudo {
  background: #fff;
  border-radius: 8px;
}

.observacao-conteudo .q-card {
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.sem-observacoes {
  text-align: center;
  padding: 24px;
  color: #666;
}

.sem-observacoes .q-icon {
  display: block;
  margin: 0 auto 8px;
}

@media (max-width: 768px) {
  .container-lista {
    padding: 0 8px;
  }

  .atividades-container {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .atividade-card {
    padding: 16px;
  }

  .atividade-titulo {
    font-size: 1.1rem;
  }

  .situacao-critica {
    font-size: 0.8rem;
  }

  .perguntas-container {
    grid-template-columns: 1fr;
    gap: 8px;
  }

  .pergunta-card {
    padding: 10px;
  }

  .pergunta-titulo {
    font-size: 0.85rem;
  }

  .pergunta-opcoes {
    flex-direction: column;
    align-items: flex-start;
    gap: 6px;
  }

  .atalho-buttons {
    padding: 8px;
  }

  .atalho-buttons .q-btn {
    width: 100%;
    margin-bottom: 8px;
  }
}

@media (max-width: 480px) {
  .atividade-header .row {
    flex-direction: column;
    gap: 12px;
  }

  .pergunta-titulo {
    font-size: 0.8rem;
  }

  .observacao-tooltip {
    max-width: 250px;
  }

  .perguntas-container {
    grid-template-columns: 1fr;
  }
}
</style>
